export default {
    parameters: {
        landing_id: "TreMt3",
    },
    downtimeUrl: "https://www.kodland.org/tr",
    startPage: {
      startBackground: "#D6FF6B",
      quizBackground: "#white",
      title: '<b>3 soruyu yanıtlayın ve ÜCRETSİZ eğlenceli bir matematik dersi alın</b>',
      subtitle: 'Bir oyun aracılığıyla matematik öğrenenimi anlatılacak. Bilgi düzeyiniz belirlenecek. Matematik becerilerini nasıl geliştirebileceğiniz gösterilecek.',
      image: {
        url:  "/welcome/quiz_turkey_math_active_pk.png",
        style: {
          height: "100%",
          "max-height": "100vh",
        },
      },
      button: {
        text: "Ücretsiz almak için tıklayın",
        style: {
          background: "#5988FF",
          color: "#FFFFFF",
          "font-weight": "bold",
        },
      },
      imageMobile: {
        url: "/welcome/quiz_turkey_math_active_mb.png",
        style: {
          width: "100%",
        },
      },
    },
    stopPage: {
      image: "/welcome/quiz_stop_page.jpg",
      title:
        "Eğitim platformumuza güvendiğiniz için teşekkür ederiz! Maalesef tabletler veya telefonlar derslerimizi almak için uygun değil. Bir dahaki sefere sizi sınıflarımızda görmekten mutluluk duyarız!",
    },
    quizRotateBySteps: {
      1: {
        question: "Çocuğunuz genellikle boş zamanlarını nasıl geçirir?",
        answers: [
          {
           answer: "🎮 Cep telefonu ve bilgisayarda oyun oynar", 
           distribution_tag_question: [48],
          },
          {
            answer: "🎨 Sanatsal faaliyetlerde bulunur: çizim, müzik, oyunculuk", 
            distribution_tag_question: [48],
          },
          {
            answer: "⚽️ Spor yapar", 
            distribution_tag_question: [48],
          },
          {
            answer: "🏕️ Ailesiyle vakit geçirir", 
            distribution_tag_question: [48],
          },
          {
            answer: "👀 Çizgi film izler", 
            distribution_tag_question: [48],
          },
          {
            answer: "🤝 Arkadaşlarıyla sosyalleşir", 
            distribution_tag_question: [48],
          }
        ],
      },
      2: {
        question: "Çocuğun matematik, mantık veya aritmetik öğrenme deneyimi var mı?",
        subtitle: "Kadın öğretmen: Çocuğunuza matematiği nasıl öğreteceğinizi öğrenin",
        answers: [
          "🏫 Evet, okulda eğitim aldı",
          "👧 Evet, kendi başına veya ebeveynlerle eğitim aldı",
          "👩‍🏫 Evet, kurslarda/çocuk branşlarında eğitim aldı",
          "😌 Hayır, deneyimi yok",
        ],
      },
      3: {
        question: "Ücretsiz olan birinci dersten beklentiniz nedir?",
        subtitle: "Kadın öğretmen: Çocuğunuza matematiği nasıl öğreteceğinizi öğrenin",
        answers: [
          "🔢 Çocuğunuzun mevcut düzeyini öğrenerek ona uygun bir eğitim planı oluşturun",
          "🎯 Zorluklarla başa çıkmayı öğrenin",
          "📈 Çocuğunuzun motivasyonunu artırın",
          "🎲 Çocuğunuza oyun yoluyla matematiği nasıl öğreteceğinizi öğrenin",
        ],
      },
      4: {
        question: "Çocuğunuzun eğitiminde sizin için en önemli olan şey nedir?",
        answers: [
          "🤩 İnteraktif ve eğlenceli aktiviteler",
          "🚀 Eğitim kalitesi",
          "💁🏼‍♂️ Bireysel yaklaşım",
          "💰 Fiyat/kalite oranı",
          "👩🏽‍🏫 Uzman öğretmen"
        ],
      },
      5: {
        title: "Deneme dersi için hangi saatte uygunsunuz?",
        type: "timeslot",
        subtitle:
          "Özel dersinizi rezerve etmek için birkaç adım kaldı! Sizinle tanışmak için sabırsızlanıyoruz🥳",
        button: "Rezervasyon için tıklayın 🎁",
      },
      6: {
        title: "Çocuğunuz kaç yaşında?",
        type: "age",
        subtitle: "Çocuğunuzun yaşına göre en eğlenceli kursu seçeceğiz",
        button: "İleri 🚀",
        featureParameter: "a_math5_7"
      },
      7: {
        title: "İsminizi girin",
        type: "parent_name",
        subtitle: "Bizim adımız Kodland, sizinki ne?👋",
        button: "İleri 🚀",
      },
      8: {
        title: "E-postanızı girin",
        type: "mail",
        subtitle: "Endişelenmeyin, spam gönderilmeyecek😅",
        button: "İleri 🚀",
      },
      9: {
        title: "Telefon numaranızı girin",
        type: "phone",
        subtitle: "Önemli konularda sizinle iletişime geçmek için kullanacağız 📞",
        button: "Neredeyse bitti 🔥",
      },
      10: {
        question: "Ücretsiz derse katılmak için çocuğunuzun bilgisayar veya dizüstü bilgisayar (telefon değil) ve sabit internet bağlantısı olması gerekir. Evinizde bilgisayar/dizüstü bilgisayar var mı?",
        answers: [
          {
            answer: "💻 Evet, evimizde var",
            distribution_tag_question: [18],
          },
          {
            answer: "❌ Hayır, evimizde yok",
            stopAnswer: true,
          },
        ],
      },
      11: {
        title: "Çocuğunuzun adı nedir?",
        type: "child_name",
        subtitle: "Veriler korunmaktadır ve talebiniz üzerine silinecektir🚨",
        button: "Son adım! 🎉",
      },
    },
    
  };
  